<div class="modal-share-profile" >
  <div class="logo-avocado-club">
    <img src="assets/imgs/fyraplus.svg" alt="">
  </div>
  <div class="title">{{'avocadoClub'|translate}}</div>

  <div class="backArrowSection">
    <ion-icon (click)="dismiss()" name="close-outline"></ion-icon>
  </div>

  <span *ngIf="!this.purchaseServiceProvider.isPremium(this.userData)" class="description">{{'avocadoClubIndicatorExplanation' | translate}}
  </span>
  <span *ngIf="!this.purchaseServiceProvider.isPremium(this.userData)" class="question-description">
    {{'wouldYouLikeToJoinTheClub'|translate}}
  </span>
  <ion-button *ngIf="!this.purchaseServiceProvider.isPremium(this.userData)" (click)="AvocadoClubIndicatorDefault('join')" class="purchase-button button-round">
      {{'joinClub' | translate}}
  </ion-button>

  <span *ngIf="this.purchaseServiceProvider.isPremium(this.userData)" class="description">{{'avocadoClubIndicatorExplanation' | translate}}
  </span>
  <div *ngIf="this.purchaseServiceProvider.isPremium(this.userData)" class="feature-buttons">
    <ion-button *ngIf="!userData?.showAvocadoClubIndicator"  (click)="AvocadoClubIndicatorDefault('enableMine')" fill="outline" color="highlight" shape="round">
      {{'enableMine' | translate}}
    </ion-button>
    <ion-button (click)="AvocadoClubIndicatorDefault('show')" shape="round" color="highlight" >
      {{'OK' | translate}}
    </ion-button>

  </div>
</div>